import type { ActionsOfCreators, FeatureHandler } from '../helpers';
import { input } from './input';
import { intent } from './intent';
import { utterance } from './utterance';
import { exportResult } from '../deployment';

export const inputActions = [exportResult, input, intent, utterance];

export type InputActions = ActionsOfCreators<typeof inputActions>;

export type InputHandler<T extends InputActions> = FeatureHandler<
  T,
  InputActions
>;
